import React, { RefObject, useEffect, useState } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { Languages } from "../../models/User";
import { Country, State } from "../../models/Geography";
import { StateLabel } from "../../constants";
import { geographiesApi } from "apis";

interface Props {
  countryRef: RefObject<HTMLElement>;
  stateRef?: RefObject<HTMLElement>;
  languageRef: RefObject<HTMLElement>;
}

export const LocaleInputs = ({
  countryRef,
  stateRef,
  languageRef,
}: Props): JSX.Element => {
  const [languageId, setLanguageId] = useState(1);
  const [countryId, setCountryId] = useState(1);
  const [stateId, setStateId] = useState(0);

  const [countries, setCountries] = useState<Country[] | undefined>();
  const [states, setStates] = useState<State[] | undefined>();

  const [displayStates, setDisplayStates] = useState<State[]>([]);

  useEffect(() => {
    (async () => {
      const [countries, states] = await Promise.all([
        geographiesApi.fetchCountries(),
        geographiesApi.fetchStates(),
      ]);
      setCountries(countries);
      setStates(states);
    })();
  }, []);

  useEffect(() => {
    if (states) {
      setDisplayStates(states.filter((state) => state.countryId === countryId));
    }
  }, [countryId]);

  return (
    <>
      <FormControl
        fullWidth
        sx={{
          my: 1,
        }}
      >
        <Select
          size="small"
          ref={languageRef}
          id="language-select"
          name="language"
          onChange={(event) => {
            const value = event.target.value as number;
            setLanguageId(value);
          }}
          value={languageId}
          fullWidth
        >
          <MenuItem value={Languages.en}>English</MenuItem>
          {countryId === countries?.find((c) => c.slug == "canada")?.id && (
            <MenuItem value={Languages.fr}>French</MenuItem>
          )}
        </Select>
      </FormControl>
      <FormControl
        fullWidth
        sx={{
          my: 1,
        }}
      >
        <Select
          size="small"
          ref={countryRef}
          id="country-select"
          name="country"
          onChange={(event) => {
            const value = event.target.value as number;
            setCountryId(value);
            if (
              value === countries?.find((c) => c.slug == "united-states")?.id
            ) {
              setLanguageId(Languages.en);
            }
          }}
          value={countryId}
          fullWidth
        >
          {countries?.map((country) => (
            <MenuItem value={country.id} key={country.id}>
              {country.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {stateRef && (
        <FormControl
          fullWidth
          sx={{
            my: 1,
          }}
        >
          <Select
            size="small"
            ref={stateRef}
            id="state-select"
            name="state"
            onChange={(event) => {
              const value = event.target.value as number;
              setStateId(value);
            }}
            value={stateId}
            fullWidth
          >
            <MenuItem value={0}>
              {countryId == 2 ? StateLabel.Canada : StateLabel.US}
            </MenuItem>
            {displayStates?.map((state: State) => (
              <MenuItem value={state.id}>{state.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};
